<div class="row justify-content-center">
    <span class="circle-modal animate-grow-circle">
        <img alt="Info" [src]="iconPath" class="info-icon"/>
    </span>
</div>

<div class="pl-lg-8 pr-lg-8 pt-lg-6 pt-0" mat-dialog-content>
    <div class="row mt-3 mb-4 pr-8 pl-8 d-flex justify-content-center">
        <span class="title-modal" innerHTML="{{ title | translate }}"></span>
    </div>
    <div class="row m-0 justify-content-center {{bodyClass}}" *ngFor="let text of texts">
        <span class="mb-3 text-modal" innerHTML="{{ text | translate }}"></span>
    </div>
</div>

<div class="justify-content-center mt-4" mat-dialog-actions>
    <button
        data-test="cop-slider-dialog-cancel-btn"
        *ngIf="showBtnCancel && textBtnCancel"
        type="button"
        class="btn btn-default btn-modal-action btn-lg mr-4"
        tabindex="-1"
        (click)="cancel()"
        translate
    >
        {{ textBtnCancel }}
    </button>

    <button
        data-test="cop-slider-dialog-confirm-btn"
        *ngIf="showBtnConfirm && textBtnConfirm"
        type="button"
        class="btn btn-default
        btn-modal-action btn-lg"
        tabindex="-1"
        (click)="confirm()"
        translate
    >
        {{ textBtnConfirm }}
    </button>
</div>
